import React, { useState } from 'react';
import { login } from '../services/authService';

const Login = ({ onLogin }) => {
  const [credenciales, setCredenciales] = useState({ nombre_usuario: '', password: '' });
  const [error, setError] = useState('');

  const handleInput = (e) => {
    setCredenciales({ ...credenciales, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const data = await login(credenciales);
      if (data.token) {
        onLogin({ ...data.usuario, token: data.token });
      } else {
        setError(data.mensaje || 'Error al iniciar sesión');
      }
    } catch (err) {
      setError('Error de conexión');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <form
        onSubmit={handleSubmit}
        className="bg-white p-6 rounded shadow-md w-full max-w-sm"
      >
        <h2 className="text-xl font-bold mb-4 text-blue-600 text-center">Zonatek Login</h2>

        {error && <p className="text-red-500 text-sm mb-3">{error}</p>}

        <input
          type="text"
          name="nombre_usuario"
          placeholder="Nombre de usuario"
          value={credenciales.nombre_usuario}
          onChange={handleInput}
          className="w-full p-2 border rounded mb-3"
        />

        <input
          type="password"
          name="password"
          placeholder="Contraseña"
          value={credenciales.password}
          onChange={handleInput}
          className="w-full p-2 border rounded mb-4"
        />

        <button
          type="submit"
          className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700"
        >
          Iniciar sesión
        </button>
      </form>
    </div>
  );
};

export default Login;
